import { VIEWS } from '../constants'
import {defaultViewsState} from '../../defaulState'
import _ from 'lodash'

const viewsReducer = (state = defaultViewsState, action) => {
    let _newState = {}

    switch (action.type) {

        case VIEWS.SHOW_EDIT_SLIDE_ANIMATION_SETTINGS:
            _newState = _.cloneDeep(state)
            _newState.editSlideAnimationSettingsDisplay = 'block'
            _newState.editSlideDrilldownsDisplay = 'none'
            _newState.elementSettingsDrilldownsDisplay = 'none'
            // _newState.editSlideAnimationSettingsTransform = 'scaleX(1)'
            break;


        case VIEWS.SHOW_EDIT_SLIDE_CAPTION_SETTINGS:
            _newState = _.cloneDeep(state)
            _newState.editSlideCaptionSettingsDisplay = 'block'
            _newState.editSlideDrilldownsDisplay = 'none'
            _newState.elementSettingsDrilldownsDisplay = 'none'
            // _newState.editSlideCaptionSettingsTransform = 'scaleX(1)'
            break;

        case VIEWS.SHOW_ELEMENT_SETTINGS:
            _newState = _.cloneDeep(state)
            _newState.elementSettingsDrilldownsDisplay = 'block'
            _newState.editSlideDrilldownsDisplay = 'none'
            _newState.editSlideSettingsDisplay = 'none'
            _newState.editSlideCaptionSettingsDisplay = 'none'
            _newState.editSlideAnimationSettingsDisplay = 'none'
            _newState.linkSettingsDisplay = 'none'
            // _newState.editSlideCaptionSettingsTransform = 'scaleX(1)'
            break;

        case VIEWS.SHOW_LINK_SETTINGS:
            _newState = _.cloneDeep(state)
            _newState.linkSettingsDisplay = 'block'
            _newState.elementSettingsDrilldownsDisplay = 'none'
            _newState.editSlideDrilldownsDisplay = 'none'
            _newState.editSlideCaptionSettingsDisplay = 'none'
            _newState.editSlideAnimationSettingsDisplay = 'none'
            // _newState.editSlideCaptionSettingsTransform = 'scaleX(1)'
            break;

        case VIEWS.SHOW_EDIT_SLIDE_SETTINGS:
            _newState = _.cloneDeep(state)
            _newState.editSlideSettingsDisplay = 'block'
            _newState.editSlideDrilldownsDisplay = 'none'
            // _newState.editSlideSettingsTransform = 'scaleX(1)'
            break;


        case VIEWS.SHOW_EDIT_SLIDE_DRILLDOWNS:
            _newState = _.cloneDeep(state)
            _newState.editSlideDrilldownsDisplay = 'block'
            _newState.editSlideSettingsDisplay = 'none'
            _newState.editSlideCaptionSettingsDisplay = 'none'
            _newState.editSlideAnimationSettingsDisplay = 'none'
            _newState.elementSettingsDrilldownsDisplay = 'none'
            _newState.linkSettingsDisplay = 'none'
            _newState.layersDisplay = 'none'
            // _newState.editSlideDrilldownsTransform = 'scaleX(1)'
            break;

        case VIEWS.SHOW_LAYERS:
            _newState = _.cloneDeep(state)
            _newState.layersDisplay = 'block'
            _newState.editSlideDrilldownsDisplay = 'none'
            _newState.editSlideSettingsDisplay = 'none'
            _newState.editSlideCaptionSettingsDisplay = 'none'
            _newState.editSlideAnimationSettingsDisplay = 'none'
            _newState.elementSettingsDrilldownsDisplay = 'none'
            _newState.linkSettingsDisplay = 'none'
            break;


        default:
            _newState = _.cloneDeep(state);
            break;
    }

    return _newState
}

export {viewsReducer}